import { GOProperties } from 'types';

export type GOPropertiesAction = never;

export default function goPropertiesReducer(state: GOProperties, action: GOPropertiesAction): GOProperties {
  return state;
}
